import { useEffect } from "react";
import type { TPeriod } from "store/periodStore";
import { fetchPeriodsWithComposites } from "store/periodStore";
import { useAppDispatch, useAppSelector } from "store/store";

import SubscriptionManagementModalContainer from "./SubscriptionManagementModalContainer";

interface SubscriptionManagementModalWrapperProps {
    onClose: () => void;
    selectedPeriod: TPeriod;
    onOpenImport?: () => void;
}

/**
 * Wrapper component that ensures composite periods are loaded before rendering the main container.
 * This prevents subscription data fetching until we know if the period has composites.
 */
const SubscriptionManagementModalWrapper = ({
    onClose,
    selectedPeriod,
    onOpenImport,
}: SubscriptionManagementModalWrapperProps) => {
    const dispatch = useAppDispatch();
    const { periodsWithCompositesFetchStatus } = useAppSelector((state) => state.period);

    // Fetch composite periods
    useEffect(() => {
        if (periodsWithCompositesFetchStatus === "idle") {
            dispatch(fetchPeriodsWithComposites());
        }
    }, [dispatch, periodsWithCompositesFetchStatus]);

    const isLoadingComposites =
        periodsWithCompositesFetchStatus === "idle" || periodsWithCompositesFetchStatus === "pending";

    // Always render the container, but pass loading state
    return (
        <SubscriptionManagementModalContainer
            onClose={onClose}
            selectedPeriod={selectedPeriod}
            onOpenImport={onOpenImport}
            isLoadingComposites={isLoadingComposites}
        />
    );
};

export default SubscriptionManagementModalWrapper;
